import { createReducer } from '@reduxjs/toolkit';
import LogActions from './actions';
import { ILog } from '../../@types/model/logging/Log';
import { IFileDownloadLog } from '../../@types/model/fileDownloadLogs/fileDownloadLog';

export interface ILogState {
    isLoading : boolean;
    logData : Array<ILog> | null;
    fileDownloadLogData : Array<IFileDownloadLog> | null;
}

const initialState = {
    isLoading: false,
    logData: null,
    fileDownloadLogData: null,
};

const freshServiceReducer = createReducer<ILogState>(initialState, (builder) => {
    builder.addCase(LogActions.setIsLoading, (state, action) => {
        state.isLoading = action.payload;
    });
    builder.addCase(LogActions.setLogData, (state, action) => {
        state.logData = action.payload;
    });
    builder.addCase(LogActions.setFileDownloadLogData, (state, action) => {
        state.fileDownloadLogData = action.payload;
    });
});

export default freshServiceReducer;
